import ScButton from "@/src/components/ui-kit/button";
import { useSubmitWikiFeedback } from "@/src/services/wiki/wiki-feedback.hooks";
import { useTheme } from "@/src/styles/theme-provider";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Text, TextInput, View } from "react-native";

/**
 * Submission form for the wiki as a whole (not scoped to one article). The
 * submitter's own past submissions render below this (see
 * WikiMyFeedbackList) — every other submission still displays as anonymous.
 */
export default function WikiFeedbackForm() {
  const { t } = useTranslation();
  const { themeVars } = useTheme();
  const [message, setMessage] = useState("");
  const { mutate: submitFeedback, isPending } = useSubmitWikiFeedback();

  const handleSubmit = () => {
    const trimmed = message.trim();
    if (!trimmed) return;

    submitFeedback(
      { message: trimmed },
      { onSuccess: () => setMessage("") },
    );
  };

  return (
    <View className="gap-3 mt-4">
      <Text className="text-sm font-semibold text-onyx">
        {t("LABEL_WIKI_FEEDBACK")}
      </Text>

      <Text className="text-xs text-ash-1">
        {t("LABEL_WIKI_FEEDBACK_ANONYMITY_NOTE")}
      </Text>

      <TextInput
        placeholder={t("PLACEHOLDER_WIKI_FEEDBACK")}
        multiline
        value={message}
        onChangeText={setMessage}
        className="min-h-[80px] px-4 py-3 text-sm text-onyx focus:outline-none bg-ash md:border md:border-ash-3 rounded-2xl"
        selectionColor={themeVars["--color-primary-default"] as string}
        placeholderTextColor={themeVars["--color-ash-2"] as string}
        underlineColorAndroid="transparent"
        accessibilityLabel={t("LABEL_WIKI_FEEDBACK")}
      />

      <ScButton
        text="BTN_SUBMIT_FEEDBACK"
        onPress={handleSubmit}
        disabled={!message.trim() || isPending}
        loading={isPending}
        className="self-start"
      />
    </View>
  );
}
